/* eslint-disable @typescript-eslint/no-confusing-void-expression */
import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Box,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import MDBox from "components/MDBox";
import { isAdmin } from "utils/userInfos";
import COLORS from "constant/colors";
import { defaultSelectedItemMpsa } from "constant/Types";
import MDButton from "components/MDButton/index";
import { PATH_DIAGNOSTIC } from "constant/moduleInfo";
import AutoCompleteComponent from "components/AutoCompleteComponent";
import { normalizeText } from "utils/textOperation";

function RubriqueDialogAction({
  selectedItem,
  handleOpenFile,
  handleUploadFile,
  handleClose,
  open,
  action,
  title,
  saveData,
  editData,
  deleteData,
  listMaladie,
  listMaladieDiagnostic,
  pathName,
  type,
}): JSX.Element {
  const { t } = useTranslation("translation");
  const { i18n } = useTranslation();
  const [item, setItem] = useState<any>(selectedItem);
  const [fileFr, setFileFr] = useState<Blob | null>(null);
  const [fileEn, setFileEn] = useState<Blob | null>(null);
  const [fileAnnex1Fr, setFileAnnex1Fr] = useState<Blob | null>(null);
  const [fileAnnex1En, setFileAnnex1En] = useState<Blob | null>(null);
  const [fileAnnex2Fr, setFileAnnex2Fr] = useState<Blob | null>(null);
  const [fileAnnex2En, setFileAnnex2En] = useState<Blob | null>(null);
  // const [file3, setFile3] = useState<Blob | null>(null);
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [arrFileInput, setArrFileInput] = useState<any>([]);
  const [arrFileInputAnnex1, setArrFileInputAnnex1] = useState<any>([]);
  const [arrFileInputAnnex2, setArrFileInputAnnex2] = useState<any>([]);
  const [maladieDiagnostic, setMaladieDiagnostic] = useState<any>(listMaladieDiagnostic);
  const [newMaladieDiagnostic, setNewMaladieDiagnostic] = useState<any>([]);
  const [removedMaladie, setRemovedMaladie] = useState<any>([]);
  const isAdminRole: boolean = isAdmin();
  // console.log("ddd", listMaladieDiagnostic);
  // const isSuperisAdminRole: boolean = isSuperAdmin();
  const handleInputChange = (e): void => {
    const { name, value } = e.target;
    // console.log("dddda", name, value);
    let updatedItem = defaultSelectedItemMpsa;
    updatedItem = { ...item, [name]: value };
    // console.log("aaa", updatedItem);
    setItem(updatedItem);
  };
  /* const chooseFile = (file: Blob, lng: string): void => {
    console.log("qqq", lng);
    if (lng === "Fr") {
      console.log("fr", lng);
      setFileFr(file);
    } else if (lng === "En") {
      console.log("En", lng);
      setFileEn(file);
    }
  }; */

  useEffect(() => {
    setArrFileInput([
      {
        id: 1,
        lng: "Fr",
        file: fileFr,
        setFile: setFileFr,
        name: item?.name ?? "",
      },
      {
        id: 2,
        lng: "En",
        file: fileEn,
        setFile: setFileEn,
        name: item?.nameEn ?? "",
      },
    ]);
  }, [fileFr, fileEn]);

  useEffect(() => {
    setArrFileInputAnnex1([
      {
        id: 1,
        lng: "Fr",
        file: fileAnnex1Fr,
        setFile: setFileAnnex1Fr,
        name: "Annexe traitement épicutanée du bétail",
      },
      {
        id: 2,
        lng: "En",
        file: fileAnnex1En,
        setFile: setFileAnnex1En,
        name: "Annex epicutaneous treatment of cattle",
      },
    ]);
  }, [fileAnnex1Fr, fileAnnex1En]);

  useEffect(() => {
    setArrFileInputAnnex2([
      {
        id: 3,
        lng: "Fr",
        file: fileAnnex2Fr,
        setFile: setFileAnnex2Fr,
        name: "Annexe pédiluve acaricide",
      },
      {
        id: 4,
        lng: "En",
        file: fileAnnex2En,
        setFile: setFileAnnex2En,
        name: "Annex the acaricide footbath",
      },
    ]);
  }, [fileAnnex2Fr, fileAnnex2En]);
  useEffect(() => {
    setArrFileInput([
      {
        id: 1,
        lng: "Fr",
        file: fileFr,
        setFile: setFileFr,
        name: item?.name ?? "",
      },
      {
        id: 2,
        lng: "En",
        file: fileEn,
        setFile: setFileEn,
        name: item?.nameEn ?? "",
      },
    ]);
    if (selectedItem.name === "Antiparasitaires") {
      setArrFileInputAnnex1([
        {
          id: 1,
          lng: "Fr",
          file: fileAnnex1Fr,
          setFile: setFileAnnex1Fr,
          name: "Annexe traitement épicutanée du bétail",
        },
        {
          id: 2,
          lng: "En",
          file: fileAnnex1En,
          setFile: setFileAnnex1En,
          name: "Annex epicutaneous treatment of cattle",
        },
      ]);
      setArrFileInputAnnex2([
        {
          id: 3,
          lng: "Fr",
          file: fileAnnex2Fr,
          setFile: setFileAnnex2Fr,
          name: "Annexe pédiluve acaricide",
        },
        {
          id: 4,
          lng: "En",
          file: fileAnnex2En,
          setFile: setFileAnnex2En,
          name: "Annex the acaricide footbath",
        },
      ]);
    }
    if (pathName === PATH_DIAGNOSTIC && listMaladie.length === 0) {
      setErrorMsg(t("noDiseaseFound"));
    }
  }, []);
  const checkFormValues = (): void => {
    setErrorMsg("");
    if (item.name === "") {
      setErrorMsg(t("noFrName"));
    } else if (item.nameEn === "") {
      setErrorMsg(t("noEnName"));
    } else if (item.name.includes("/") === true || item.nameEn.includes("/") === true) {
      setErrorMsg(t("slashNotAccepted"));
    } else if (pathName === PATH_DIAGNOSTIC && maladieDiagnostic.length === 0) {
      setErrorMsg(t("noDiseaseSelected"));
    } else if (action === "add") {
      if (fileFr === null) {
        setErrorMsg(t("noFrFile"));
      } else if (fileEn === null) {
        setErrorMsg(t("noEnFile"));
      } else {
        const arrFile = [
          {
            lng: "Fr",
            file: fileFr,
            name: item.name,
          },
          {
            lng: "En",
            file: fileEn,
            name: item.nameEn,
          },
        ];
        if (action === "add") {
          saveData(arrFile, item, newMaladieDiagnostic);
        }
        // console.log("new maladie ", newMaladieDiagnostic);
        // console.log("new item ", item);
      }
    } else if (action === "edit") {
      console.log("edit", item, newMaladieDiagnostic, removedMaladie);
      editData(item, newMaladieDiagnostic, removedMaladie);
    }
    console.log("ssss", removedMaladie);
  };
  const handleInputChangeMaladie = (e): void => {
    const { value } = e.target;
    const existingMaladie: any = new Set(
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      listMaladieDiagnostic.map((i: { name: string }) => i.name)
    );
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    const newMaladie = value.newValue.filter((i: { name: string }) => !existingMaladie.has(i.name));

    const uniqueMaladie = new Set();
    const selectedMaladie = value.newValue.filter((i: { name: string }) => {
      if (uniqueMaladie.has(i.name)) {
        return false;
      }
      uniqueMaladie.add(i.name);
      return true; // Inclure cet élément
    });

    setMaladieDiagnostic(selectedMaladie);
    setNewMaladieDiagnostic(newMaladie);
    console.log("newMaladie", newMaladie);
    console.log("selectedMaladie", selectedMaladie);
    // }
  };

  const handleRemoveMaladie = (maladieToRemove): void => {
    // const currentRoles = userRole || [];
    try {
      const MaladieValue = maladieDiagnostic.filter(
        (i: { name: string }) => i.name !== maladieToRemove.name
      );
      const newRole = newMaladieDiagnostic.filter(
        (i: { name: string }) => i.name !== maladieToRemove.name
      );
      // const UserRoleValue = currentRoles.filter((i) => i.roleName !== roleToRemove.roleName);
      setMaladieDiagnostic(MaladieValue);
      setNewMaladieDiagnostic(newRole);
      const deletedRole = listMaladieDiagnostic.filter(
        (i: { name: string }) => i.name === maladieToRemove.name
      );
      // const deletedRole = [...removedUserRole, ...deletedRoleValue];
      setRemovedMaladie(deletedRole);
    } catch (error) {
      console.log("handleRemoveRole error", error);
    }
    // console.log("roleToRemove", roleToRemove);
  };
  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{action === "add" ? t("add") : t("detail")}</DialogTitle>
        <DialogContent>
          <p>{selectedItem.title}</p>
          {isAdminRole && (
            <>
              <TextField
                label={`${t("name")} FR`}
                name="name"
                value={item?.name}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    checkFormValues();
                  }
                }}
              />
              <TextField
                label={`${t("name")} En`}
                name="nameEn"
                value={item?.nameEn}
                onChange={handleInputChange}
                fullWidth
                margin="normal"
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    checkFormValues();
                  }
                }}
              />
            </>
          )}
          {pathName === PATH_DIAGNOSTIC && (
            <AutoCompleteComponent
              options={listMaladie}
              name="maladies"
              label="Maladies"
              value={maladieDiagnostic}
              onChange={handleInputChangeMaladie}
              // onRemove={handleInputRemoveRole}
              isResultObject
              isMultiSelect
              onRemove={handleRemoveMaladie}
              // isDisabled={action === "edit"}
            />
          )}
          {isAdminRole && action === "edit" && (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{ marginBottom: 2 }}
            >
              <MDButton type="submit" variant="gradient" color="info" onClick={checkFormValues}>
                {t("edit")}
              </MDButton>
            </Box>
          )}
          {arrFileInput.map((i) => (
            <Stack
              key={i.id}
              spacing={2}
              direction={{ xs: "column", sm: "row" }} // Change direction to column on small screens
              sx={{
                backgroundColor: "#ffe1c3",
                padding: { xs: "10px", sm: "20px" }, // Adjust padding for different screen sizes
                alignItems: "center", // Center items for better layout on small screens
                width: "100%",
              }}
            >
              <MDBox mb={2}>
                {isAdminRole && (
                  <>
                    <label
                      htmlFor={`upload-${i.id}`}
                      style={{
                        display: "inline-block",
                        padding: "10px 20px",
                        backgroundColor: COLORS.primary,
                        color: "#fff",
                        borderRadius: "5px",
                        cursor: "pointer",
                        textAlign: "center",
                      }}
                    >
                      {t("choose_file")} {i.lng}
                    </label>
                    <input
                      type="file"
                      key={`input-${i.id}`} // Add unique key
                      name={`upload-${i.id}`}
                      id={`upload-${i.id}`} // Match the label's htmlFor
                      // onChange={onChangeFile}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        if (e.target.files !== null) {
                          const selectedFile = e.target.files[0];
                          const fileSizeInMB = selectedFile.size / (1024 * 1024);
                          if (fileSizeInMB > 1) {
                            setErrorMsg(t("heavyFile"));
                            setTimeout(() => {
                              setErrorMsg("");
                            }, 4000);
                          } else {
                            i.setFile(e.target.files[0] as Blob);
                          }
                          //
                          // console.log("qqqq//", e.target.files[0]);
                          // chooseFile(e.target.files[0] as Blob, i.lng);
                        }
                      }}
                      accept="application/pdf"
                      // style={{ width: "100%", maxWidth: "100%" }}
                      style={{ display: "none" }}
                    />
                  </>
                )}
              </MDBox>
              {i.file === null ? (
                <>
                  {action === "edit" && isAdminRole && (
                    <Button
                      key={`input-${i.id}`}
                      // onClick={() => handleOpenFile(selectedItem.title, false)}
                      onClick={() => handleOpenFile(i.name, false, null, type)}
                      color="primary"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        //  width: { xs: "100%", sm: "auto" },
                      }}
                    >
                      {t("see_file")} {i?.name} {i.lng}
                    </Button>
                  )}
                  {action === "edit" &&
                    !isAdminRole &&
                    normalizeText(i.lng as string) === normalizeText(i18n.resolvedLanguage) && (
                      <Button
                        key={`download-${i.id}-Annex`}
                        name={`download-${i.id}Annex`}
                        id={`download-${i.id}Annex`}
                        // onClick={() => handleOpenFile(selectedItem.title, false)}
                        onClick={() => handleOpenFile(i.name, false, null, type)}
                        color="primary"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          //  width: { xs: "100%", sm: "auto" },
                        }}
                      >
                        {t("see_file")} {i?.name} {i.lng}
                      </Button>
                    )}
                </>
              ) : (
                <>
                  {action === "edit" ? (
                    <Button
                      key={`input-${i.id}`}
                      // onClick={() => handleUploadFile(i.file, selectedItem.title)}
                      onClick={() => handleUploadFile(i, false)}
                      color="primary"
                      autoFocus
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      {t("upload_file")} {selectedItem?.name} {i.lng}
                    </Button>
                  ) : (
                    <Typography variant="body2" color="success" sx={{ mt: 1 }}>
                      {i.file?.name}
                    </Typography>
                  )}
                </>
              )}
            </Stack>
          ))}
          {selectedItem.name === "Antiparasitaires" && (
            <div>
              {/* <>
                <p> {t("annex")} 1</p>
                <Stack
                  spacing={2}
                  direction={{ xs: "column", sm: "row" }} // Change direction to column on small screens
                  sx={{
                    backgroundColor: "#ffe1c3",
                    padding: { xs: "10px", sm: "20px" }, // Adjust padding for different screen sizes
                    alignItems: "center",
                    // Center items for better layout on small screens
                  }}
                >
                  {isAdminRole && (
                    <MDBox mb={2}>
                      <input
                        type="file"
                        name="upload"
                        id="upload"
                        // onChange={onChangeFile}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          if (e.target.files !== null) {
                            setFile2(e.target.files[0] as Blob);
                          }
                        }}
                        accept="application/pdf"
                        style={{ width: "100%", maxWidth: "100%" }}
                      />
                    </MDBox>
                  )}
                  {file2 === null ? (
                    <Button
                      onClick={() =>
                        handleOpenFile("Traitement épicutané du bétail", false, null, type)
                      }
                      color="primary"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      {`${t("see_file")} ${t("annexTraitementEpicutanee")}`}
                    </Button>
                  ) : (
                    <Button
                      onClick={() => handleUploadFile(file2, "Traitement épicutané du bétail")}
                      color="primary"
                      autoFocus
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      Uploader l&apos;annexe Traitement épicutané du bétail
                    </Button>
                  )}
                </Stack>
                <p> {t("annex")} 2</p>
                <Stack
                  spacing={2}
                  direction={{ xs: "column", sm: "row" }} // Change direction to column on small screens
                  sx={{
                    backgroundColor: "#ffe1c3",
                    padding: { xs: "10px", sm: "20px" }, // Adjust padding for different screen sizes
                    alignItems: "center", // Center items for better layout on small screens
                  }}
                >
                  {isAdminRole && (
                    <MDBox mb={2}>
                      <input
                        type="file"
                        name="upload"
                        id="upload"
                        // onChange={onChangeFile}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          if (e.target.files !== null) {
                            setFile3(e.target.files[0] as Blob);
                          }
                        }}
                        accept="application/pdf"
                        style={{ width: "100%", maxWidth: "100%" }}
                      />
                    </MDBox>
                  )}
                  {file3 === null ? (
                    <Button
                      onClick={() => handleOpenFile("pédiluve acaricide", false, null, type)}
                      color="primary"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      {`${t("see_file")} ${t("annexPediluve")}`}
                    </Button>
                  ) : (
                    <Button
                      onClick={() => handleUploadFile(file3, "pédiluve acaricide")}
                      color="primary"
                      autoFocus
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      Uploader l&apos;annexe Pédiluve Acaricide
                    </Button>
                  )}
                </Stack>
              </> */}
              <>
                <p> {t("annex")} 1</p>
                {arrFileInputAnnex1.map((i) => (
                  <Stack
                    key={`stack-${i.id}Annex`}
                    spacing={2}
                    direction={{ xs: "column", sm: "row" }} // Change direction to column on small screens
                    sx={{
                      backgroundColor: "#ffe1c3",
                      padding: { xs: "10px", sm: "20px" }, // Adjust padding for different screen sizes
                      alignItems: "center", // Center items for better layout on small screens
                      width: "100%",
                    }}
                  >
                    <MDBox mb={2}>
                      {isAdminRole && (
                        <>
                          <label
                            htmlFor={`upload-${i.id}Annex`}
                            style={{
                              display: "inline-block",
                              padding: "10px 20px",
                              backgroundColor: COLORS.primary,
                              color: "#fff",
                              borderRadius: "5px",
                              cursor: "pointer",
                              textAlign: "center",
                            }}
                          >
                            {t("choose_file")} {i.lng}
                          </label>
                          <input
                            type="file"
                            key={`input-${i.id}Annex`} // Add unique key
                            name={`input-${i.id}Annex`}
                            id={`upload-${i.id}Annex`} // Match the label's htmlFor
                            // onChange={onChangeFile}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                              if (e.target.files !== null) {
                                const selectedFile = e.target.files[0];
                                const fileSizeInMB = selectedFile.size / (1024 * 1024);
                                if (fileSizeInMB > 1) {
                                  setErrorMsg(t("heavyFile"));
                                  setTimeout(() => {
                                    setErrorMsg("");
                                  }, 4000);
                                } else {
                                  i.setFile(e.target.files[0] as Blob);
                                }
                                //
                                console.log("qqqq//", e.target.files[0]);
                                console.log("qqqq//", i);
                                // chooseFile(e.target.files[0] as Blob, i.lng);
                              }
                            }}
                            accept="application/pdf"
                            // style={{ width: "100%", maxWidth: "100%" }}
                            style={{ display: "none" }}
                          />
                        </>
                      )}
                    </MDBox>
                    {i.file === null ? (
                      <>
                        {action === "edit" && isAdminRole && (
                          <Button
                            key={`download-${i.id}-Annex`}
                            name={`download-${i.id}Annex`}
                            id={`download-${i.id}Annex`}
                            // onClick={() => handleOpenFile(selectedItem.title, false)}
                            onClick={() => handleOpenFile(i.name, false, null, type)}
                            color="primary"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              textAlign: "center",
                              //  width: { xs: "100%", sm: "auto" },
                            }}
                          >
                            {t("see_file")} {i?.name} {i.lng}
                          </Button>
                        )}
                        {action === "edit" &&
                          !isAdminRole &&
                          normalizeText(i.lng as string) ===
                            normalizeText(i18n.resolvedLanguage) && (
                            <Button
                              key={`download-${i.id}-Annex`}
                              name={`download-${i.id}Annex`}
                              id={`download-${i.id}Annex`}
                              // onClick={() => handleOpenFile(selectedItem.title, false)}
                              onClick={() => handleOpenFile(i.name, false, null, type)}
                              color="primary"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                                //  width: { xs: "100%", sm: "auto" },
                              }}
                            >
                              {t("see_file")} {i?.name} {i.lng}
                            </Button>
                          )}
                      </>
                    ) : (
                      <>
                        {action === "edit" ? (
                          <Button
                            key={`upload-${i.id}-Annex`}
                            name={`upload-${i.id}Annex`}
                            id={`upload-${i.id}Annex`}
                            // onClick={() => handleUploadFile(i.file, selectedItem.title)}
                            onClick={() => handleUploadFile(i, false)}
                            color="primary"
                            autoFocus
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            {t("upload_file")} {i?.name} {i.lng}
                          </Button>
                        ) : (
                          <Typography variant="body2" color="success" sx={{ mt: 1 }}>
                            {i.file?.name}
                          </Typography>
                        )}
                      </>
                    )}
                  </Stack>
                ))}
                <p> {t("annex")} 2</p>
                {arrFileInputAnnex2.map((i) => (
                  <Stack
                    key={`stack-${i.id}Annex`}
                    spacing={2}
                    direction={{ xs: "column", sm: "row" }} // Change direction to column on small screens
                    sx={{
                      backgroundColor: "#ffe1c3",
                      padding: { xs: "10px", sm: "20px" }, // Adjust padding for different screen sizes
                      alignItems: "center", // Center items for better layout on small screens
                      width: "100%",
                    }}
                  >
                    <MDBox mb={2}>
                      {isAdminRole && (
                        <>
                          <label
                            htmlFor={`upload-${i.id}Annex`}
                            style={{
                              display: "inline-block",
                              padding: "10px 20px",
                              backgroundColor: COLORS.primary,
                              color: "#fff",
                              borderRadius: "5px",
                              cursor: "pointer",
                              textAlign: "center",
                            }}
                          >
                            {t("choose_file")} {i.lng}
                          </label>
                          <input
                            type="file"
                            key={`input-${i.id}Annex`} // Add unique key
                            name={`input-${i.id}Annex`}
                            id={`upload-${i.id}Annex`} // Match the label's htmlFor
                            // onChange={onChangeFile}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                              if (e.target.files !== null) {
                                const selectedFile = e.target.files[0];
                                const fileSizeInMB = selectedFile.size / (1024 * 1024);
                                if (fileSizeInMB > 1) {
                                  setErrorMsg(t("heavyFile"));
                                  setTimeout(() => {
                                    setErrorMsg("");
                                  }, 4000);
                                } else {
                                  i.setFile(e.target.files[0] as Blob);
                                }
                                //
                                console.log("qqqq//", e.target.files[0]);
                                console.log("qqqq//", i);
                                // chooseFile(e.target.files[0] as Blob, i.lng);
                              }
                            }}
                            accept="application/pdf"
                            // style={{ width: "100%", maxWidth: "100%" }}
                            style={{ display: "none" }}
                          />
                        </>
                      )}
                    </MDBox>
                    {i.file === null ? (
                      <>
                        {action === "edit" && isAdminRole && (
                          <Button
                            key={`download-${i.id}-Annex`}
                            name={`download-${i.id}Annex`}
                            id={`download-${i.id}Annex`}
                            // onClick={() => handleOpenFile(selectedItem.title, false)}
                            onClick={() => handleOpenFile(i.name, false, null, type)}
                            color="primary"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              textAlign: "center",
                              //  width: { xs: "100%", sm: "auto" },
                            }}
                          >
                            {t("see_file")} {i?.name} {i.lng}
                          </Button>
                        )}
                        {action === "edit" &&
                          !isAdminRole &&
                          normalizeText(i.lng as string) ===
                            normalizeText(i18n.resolvedLanguage) && (
                            <Button
                              key={`download-${i.id}-Annex`}
                              name={`download-${i.id}Annex`}
                              id={`download-${i.id}Annex`}
                              // onClick={() => handleOpenFile(selectedItem.title, false)}
                              onClick={() => handleOpenFile(i.name, false, null, type)}
                              color="primary"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                                //  width: { xs: "100%", sm: "auto" },
                              }}
                            >
                              {t("see_file")} {i?.name} {i.lng}
                            </Button>
                          )}
                      </>
                    ) : (
                      <>
                        {action === "edit" ? (
                          <Button
                            key={`upload-${i.id}-Annex`}
                            name={`upload-${i.id}Annex`}
                            id={`upload-${i.id}Annex`}
                            // onClick={() => handleUploadFile(i.file, selectedItem.title)}
                            onClick={() => handleUploadFile(i, false)}
                            color="primary"
                            autoFocus
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            {t("upload_file")} {i?.name} {i.lng}
                          </Button>
                        ) : (
                          <Typography variant="body2" color="success" sx={{ mt: 1 }}>
                            {i.file?.name}
                          </Typography>
                        )}
                      </>
                    )}
                  </Stack>
                ))}
              </>
            </div>
          )}
          <Typography variant="body2" color="error" sx={{ mt: 1 }}>
            {errorMsg}
          </Typography>
          {isAdminRole && action === "add" && (
            <Box display="flex" alignItems="center" justifyContent="center" sx={{ marginTop: 5 }}>
              <MDButton type="submit" variant="gradient" color="info" onClick={checkFormValues}>
                {t("save")}
              </MDButton>
            </Box>
          )}
          {isAdminRole && action === "edit" && (
            <Box display="flex" alignItems="center" justifyContent="center" sx={{ marginTop: 5 }}>
              <MDButton
                type="submit"
                variant="gradient"
                color="error"
                onClick={() => deleteData(selectedItem)}
              >
                {t("delete")}
              </MDButton>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
RubriqueDialogAction.defaultProps = {
  selectedItem: {
    id: 0,
    title: "",
    description: "",
  },
  handleOpenFile: () => {},
  handleUploadFile: () => {},
  handleClose: () => {},
  open: false,
  action: "",
  title: "",
  saveData: () => {},
  editData: () => {},
  deleteData: () => {},
  listMaladie: [],
  listMaladieDiagnostic: [],
  pathName: "",
  type: "",
};
RubriqueDialogAction.propTypes = {
  selectedItem: PropTypes.any,
  handleOpenFile: PropTypes.func,
  handleUploadFile: PropTypes.func,
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  action: PropTypes.string,
  title: PropTypes.string,
  saveData: PropTypes.func,
  editData: PropTypes.func,
  deleteData: PropTypes.func,
  listMaladie: PropTypes.array,
  listMaladieDiagnostic: PropTypes.array,
  pathName: PropTypes.string,
  type: PropTypes.string,
};
export default RubriqueDialogAction;
